import { Button, buttonVariants } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTeams } from "@/contexts/teams-provider";
import { useTranslation } from "@/hooks/useTranslation";
import { cn } from "@/lib/utils";
import { TriangleAlertIcon } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";

export default function NavTeamTrial() {
  const { teamSelected, isManager, isAdmin } = useTeams();
  const { t } = useTranslation();

  const [trialEndsAt, setTrialEndsAt] = useState<Date | null>(null);

  useEffect(() => {
    if (teamSelected && teamSelected?.trialEndsAt) {
      setTrialEndsAt(new Date(teamSelected.trialEndsAt));
    }
  }, [teamSelected]);

  const daysLeft = useMemo(() => {
    if (!trialEndsAt) {
      return 0;
    }

    const now = new Date();
    const daysLeft = Math.ceil(
      (trialEndsAt.getTime() - now.getTime()) / (1000 * 60 * 60 * 24),
    );

    return daysLeft > 0 ? daysLeft : 0;
  }, [trialEndsAt]);

  if (!trialEndsAt) {
    return;
  }

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        {isManager || isAdmin ? (
          <NavLink
            to="/team/billing"
            className={cn(
              buttonVariants({
                variant: daysLeft <= 7 ? "warning" : "outline",
              }),
            )}
          >
            {t("teamTrial.daysLeft", { count: daysLeft })}
          </NavLink>
        ) : (
          <Button variant={daysLeft <= 7 ? "warning" : "outline"}>
            {t("teamTrial.daysLeft", { count: daysLeft })}
          </Button>
        )}
      </TooltipTrigger>
      <TooltipContent side="bottom" align="end">
        <div className="flex items-center space-x-2">
          <TriangleAlertIcon className="w-4 h-4 text-warning" />
          <div>
            {t("teamTrial.trialEndsAt", {
              date: trialEndsAt.toLocaleDateString(),
            })}
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
